(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('UploadController', UploadController);

	UploadController.$inject = ['$scope', 'Upload'];

	function UploadController($scope, Upload){

		/* jshint validthis: true */
		var self = this;

		/** begin methods */

		self.log = '';

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			self.$watch('files', function() {
				if (! self.files) return;

				self.files.forEach(function(file){
					self.upload = Upload.upload({
						url: "https://api.cloudinary.com/v1_1/pwc/upload",
						fields: {
							upload_preset: 'offmoeba',
							tags: 'directtest'
						},
						file: file
					}).progress(function (e) {
						file.progress = Math.round((e.loaded * 100.0) / e.total);
						file.status = "Uploading... " + file.progress + "%";

						if(! $scope.$$phase) {
							$scope.$apply();
						}

					}).success(function (data, status, headers, config) {
						//$rootScope.photos = $rootScope.photos || [];
						data.context = {custom: {photo: self.title}};
						file.result = data;
						//$rootScope.photos.push(data);
						if(! $scope.$$phase) {
							$scope.$apply();
						}
					});
				});
			});

		}
	}

})();
